module.exports = __webpack_public_path__ + "static/Close_Icon-9028d63b8e9e810604c972166f8fbf31.svg";